document.addEventListener('DOMContentLoaded', function() {
  // Find the product form (Dawn)
  const formEl =
    document.querySelector('product-form form') ||
    document.querySelector('form[action^="/cart/add"]');
  if (!formEl) return;

  // Get radio group (if block present on this product)
  const radios = document.querySelectorAll('input[name="wdlAddon"]');
  if (!radios.length) return;

  // Your add-on variant IDs (from Admin)
  const IDS = {
    tiktok:    51823899869368, // $6
    facebook:  51823899902136, // $6
    packaging: 51823899934904, // $8
    bundle:    51823899967672  // $12
  };

  // Price deltas used for on-page display only
  const DELTAS = { none: 0, tiktok: 6, facebook: 6, packaging: 8, bundle: 12 };

  // Price elements in Dawn
  const priceEl   = document.querySelector('.price .price-item--regular');
  const compareEl = document.querySelector('.price .price-item--compare');

  const parseNum = (t) => Number((t || '').replace(/[^0-9.,]/g, '').replace(',', '.'));
  const getPrefix = (t) => {
    const m = (t || '').match(/^[^\d]+/);
    return m ? m[0] : '';
  };

  // Read base price displayed for current variant (ASMR/Talking must have same price)
  const base = priceEl ? parseNum(priceEl.textContent) : 0;
  const currencyPrefix = priceEl ? getPrefix(priceEl.textContent) : '$';

  function format(n) {
    return currencyPrefix + n.toFixed(2);
  }
  function currentAddon() {
    const sel = document.querySelector('input[name="wdlAddon"]:checked');
    return sel ? sel.value : 'none';
  }
  function refreshPrice() {
    if (!priceEl) return;
    const delta = DELTAS[currentAddon()] || 0;
    priceEl.textContent = format(base + delta);
    if (compareEl) {
      const baseCompare = parseNum(compareEl.textContent);
      if (baseCompare) compareEl.textContent = format(baseCompare + delta);
    }
  }

  // Update price live when radios change
  document.addEventListener('change', (e) => {
    if (e.target && e.target.name === 'wdlAddon') refreshPrice();
  });

  // Intercept submit only when an add-on is selected
  formEl.addEventListener('submit', function(e) {
    const sel = currentAddon();
    if (sel === 'none') return; // normal add-to-cart

    e.preventDefault();

    // 1) Add the bundle variant from the form
    const fd = new FormData(formEl);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then((r) => r.json())
      .then(() => {
        // 2) Add selected add-on as separate line item
        const addonId = IDS[sel];
        if (!addonId) throw new Error('Missing add-on ID for: ' + sel);
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: addonId,
                quantity: 1,
                properties: { 'Linked to': document.title }
              }
            ]
          })
        });
      })
      .then(() => {
        // Simpler UX: go to cart. If you use a cart drawer, I can switch to that.
        window.location.href = '/cart';
      })
      .catch((err) => {
        console.error('Add-on flow error:', err);
        formEl.submit(); // fallback to normal behavior
      });
  });

  // Initial paint
  refreshPrice();
});
